import { checkDateOrder, formatDateString, getDefaultValue } from "components/CommonLib/CommonLib";
import { VAULT_CASH_TYPE } from "components/CommonLib/Consts";
import ComboBox from "components/LabelInput/ComboBox";
import DatePicker from "components/LabelInput/DatePicker";
import Label from "components/LabelInput/Label";
import SearchComboBox from "components/LabelInput/SearchComboBox";
import TextField from "components/LabelInput/TextField";
import { useEffect, useState } from "react";
import { useVaultCashStore } from "./modules/store/vaultCashState";
import { SearchConditionBox, SearchContainer, SearchRowBox } from "./style";

const SearchCondition = ({
  searchParams,
  setSearchParams,
  resetFlag,
  hqBranchData,
  hqBranchCombo,
  setHqBranchCombo,
  onClickSearch,
}) => {
  const labelWidth = "6.5rem";
  const labelWidthShort = "4.5rem";
  const textBoxWidth = "15rem";
  const textBoxWidthShort = "10rem";

  // 페이지 상태 관리
  const { vaultCashHqIdx: hqIdx, setHqIdx } = useVaultCashStore();
  const [isFirstEnterPage, setIsFirstEnterPage] = useState(true);

  // 본부 선택 시 지점 정보 첫번째 값 세팅
  useEffect(() => {
    if (!isFirstEnterPage) {
      setHqBranchCombo("selected_branch_info", hqBranchData.data[hqIdx].branch_list[0]);
    }
  }, [hqIdx]);

  // 초기화 시 본부 및 지점 첫번째 값 세팅
  useEffect(() => {
    if (!isFirstEnterPage && hqBranchData.data.length > 0) {
      setHqBranchCombo("selected_hq_info", hqBranchData.data[0].hq_info);
      setHqBranchCombo("selected_branch_info", hqBranchData.data[0].branch_list[0]);
    }
  }, [resetFlag]);

  // 첫 페이지 여부 체크
  useEffect(() => {
    setIsFirstEnterPage(false);
  }, []);

  return (
    <SearchContainer
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          // setPage(1);
          onClickSearch(1);
        }
      }}
    >
      <Label labelText="검색 조건" fontWeight="bold" justifyContent="flex-start" />
      <SearchRowBox>
        <SearchConditionBox width="26.5%">
          <ComboBox
            labelWidth={labelWidth}
            comboItemWidth={textBoxWidth}
            labelText="본부"
            data={hqBranchData && hqBranchData.hq_list}
            defaultValue={getDefaultValue("combo", hqBranchCombo.selected_hq_info.hq_name)}
            onChangeCallback={(e, idx) => {
              setHqIdx(idx);
              setHqBranchCombo("selected_hq_info", hqBranchData.data[idx].hq_info);
            }}
          />
        </SearchConditionBox>
        <SearchConditionBox width="25.5%">
          <SearchComboBox
            labelWidth={labelWidthShort}
            comboItemWidth={textBoxWidth}
            labelText="지점"
            data={hqBranchData && hqBranchData.data[hqIdx].branch_name_list}
            defaultValue={getDefaultValue("combo", hqBranchCombo.selected_branch_info.branch_name)}
            onChangeCallback={(e, v, idx) => {
              setHqBranchCombo("selected_branch_info", hqBranchData.data[hqIdx].branch_list[idx]);
            }}
          />
        </SearchConditionBox>
        <SearchConditionBox width="26.5%">
          <DatePicker
            labelText="날짜"
            labelWidth={labelWidthShort}
            textBoxWidth={textBoxWidthShort}
            labelMarginRight="0rem"
            textMarginRight="0rem"
            defaultValue={getDefaultValue("field", formatDateString(searchParams.start_date))}
            onChangeCallback={(e) => {
              setSearchParams("start_date", e + " 00:00:00");
            }}
            onBlur={(e) => {
              if (!checkDateOrder(e, searchParams.end_date)) {
                setSearchParams("start_date", "");
              }
            }}
          />
          <DatePicker
            marginLeft="0.25rem"
            labelWidth="0.5rem"
            textBoxWidth={textBoxWidthShort}
            labelMarginRight="0.25rem"
            labelText="~"
            defaultValue={getDefaultValue("field", formatDateString(searchParams.end_date))}
            onChangeCallback={(e) => {
              setSearchParams("end_date", e + " 23:59:59");
            }}
            onBlur={(e) => {
              if (!checkDateOrder(searchParams.start_date, e)) {
                setSearchParams("end_date", "");
              }
            }}
          />
        </SearchConditionBox>
      </SearchRowBox>
      <SearchRowBox>
        <SearchConditionBox width="26.5%">
          <ComboBox
            labelWidth={labelWidth}
            comboItemWidth={textBoxWidth}
            labelText="시재금 입출 구분"
            data={["전체", VAULT_CASH_TYPE.INCOME, VAULT_CASH_TYPE.EXPENSE]}
            defaultValue={getDefaultValue(
              "combo",
              searchParams.transaction_type === "지출"
                ? VAULT_CASH_TYPE.EXPENSE
                : searchParams.transaction_type,
            )}
            onChangeCallback={(e) => {
              if (e.target.value === VAULT_CASH_TYPE.INCOME) {
                setSearchParams("transaction_type", "수입");
              } else if (e.target.value === VAULT_CASH_TYPE.EXPENSE) {
                setSearchParams("transaction_type", "지출");
              } else {
                // 전체
                setSearchParams("transaction_type", "");
              }
            }}
          />
        </SearchConditionBox>
        <SearchConditionBox width="25.5%">
          <TextField
            labelText="담당자"
            labelWidth={labelWidthShort}
            textBoxWidth={textBoxWidth}
            defaultValue={getDefaultValue("field", searchParams.operator)}
            onChangeCallback={(e) => {
              setSearchParams("operator", e);
            }}
          />
        </SearchConditionBox>
      </SearchRowBox>
    </SearchContainer>
  );
};
export default SearchCondition;
